import { datadogRum } from '@datadog/browser-rum'

import { isRumEnabledForCompany } from 'modules/core/lib/datadogRumUtils'

interface DatadogTrackingData {
  userId: number
  accessId: number
  companyId: number
  companyName: string
  datadogEnvironment: string
  allowedCompanyIds: number[]
}

const runDatadog = ({
  userId,
  accessId,
  companyId,
  companyName,
  datadogEnvironment,
  allowedCompanyIds,
}: DatadogTrackingData) => {
  if (!isRumEnabledForCompany(datadogEnvironment, allowedCompanyIds, companyId)) {
    return
  }

  datadogRum.setUser({
    id: userId.toString(),
    accessId,
    companyId,
    companyName,
  })
}

export default runDatadog
